import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	discoverButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'jolt.jira-side-nav-rovo-dev-adoption-ipm.code-review.heading',
		defaultMessage: 'AI for software teams, now helping you review your pull requests',
		description:
			"Heading displayed in the Rovo Dev adoption in-product message in the Jira side navigation. This variant promotes Rovo Dev's code review capabilities specifically. The message highlights AI assistance for pull request review workflows.",
	},
	discoverButton: {
		id: 'jolt.jira-side-nav-rovo-dev-adoption-ipm.code-review.discover-button',
		defaultMessage: 'Discover Rovo Dev',
		description:
			'Label for the primary call-to-action button in the Rovo Dev adoption in-product message displayed in the Jira side navigation. Invites users to learn more about and start using Rovo Dev.',
	},
});
